import axios from 'axios'
axios.defaults.timeout = 10000
axios.defaults.withCredentials = true

axios.interceptors.response.use((res) => {
  const data = res.data
  /*
   * status === 'ok'   常用接口
   * status === '200'  filepicker
   * status === 'undefined' && data.stamp mc的文件目录
   */
  if (res.status === 200 && data.status === 'ok') {
    return data
  }
  return Promise.reject(res)
}, (error) => {
  return Promise.reject(error)
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/myaxios.js